import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "h-screen w-screen flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-5/10 md:w-5/12 lg:w-46 max-w-lg h-4/4 bg-white shadow rounded-md p-4 mt-10 md:mt-40 flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-1xl pt-7 text-center" }, "Zona de administración")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_alert = _resolveComponent("alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      loading: $setup.data_.loading
    }, null, 8, ["loading"]),
    _createVNode(_component_alert, {
      onOnFire: $setup.eventCloseAlert,
      data_alert: $setup.data_alert
    }, null, 8, ["onOnFire", "data_alert"]),
    _hoisted_1
  ], 64))
}